import { render, staticRenderFns } from "./stats-filter.vue?vue&type=template&id=0dc8f6aa&scoped=true&"
import script from "./stats-filter.vue?vue&type=script&lang=js&"
export * from "./stats-filter.vue?vue&type=script&lang=js&"
import style0 from "./stats-filter.vue?vue&type=style&index=0&id=0dc8f6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8f6aa",
  null
  
)

export default component.exports